import { format } from "date-fns";

export const getPatientInformations = authentForm => {
    const { values } = authentForm;
    const { ipp, birthdate } = values;
    const birthDate = format(birthdate, "yyyy-MM-dd");

    return { birthDate, ipp };
};
